import { render, staticRenderFns } from "./PieChartDevice.vue?vue&type=template&id=28d4216f&"
import script from "./PieChartDevice.vue?vue&type=script&lang=js&"
export * from "./PieChartDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports